import { Navigate, Outlet } from 'react-router-dom';

import { DEFAULT_ROLE_PATH, ROUTE_PATH } from 'constants/routes';
import { UserRole } from 'enums';
import {
  AdminLayout,
  MerchantLayout,
  OperatorLayout,
  TechOperatorLayout,
  TraderLayout,
} from 'layouts';
import { authUtils } from 'utils';

const redirectToLogin = () => <Navigate to={ROUTE_PATH.PUBLIC.LOGIN} replace />;

const redirectToRoleDefault = () => {
  if (DEFAULT_ROLE_PATH[authUtils.getUserRole()]) {
    return <Navigate to={DEFAULT_ROLE_PATH[authUtils.getUserRole()]} replace />;
  }
  authUtils.resetAuthData();
  return redirectToLogin();
};

type AuthenticatedRoleRouteProps = {
  role: UserRole | UserRole[];
  children: React.ReactElement;
};
const AuthenticatedRoleRoute = (props: AuthenticatedRoleRouteProps) => {
  if (!authUtils.isLoggedIn()) {
    return redirectToLogin();
  }
  const roles = Array.isArray(props.role) ? props.role : [props.role];
  if (!roles.some((role) => authUtils.isUserRole(role))) {
    return redirectToRoleDefault();
  }
  return props.children;
};

export const MerchantOnly = () => {
  if (authUtils.isUserRole(UserRole.MerchantOperator)) {
    return <Navigate to={ROUTE_PATH.MERCHANT.SHOPS} replace />;
  }
  return <Outlet />;
};

export const AdminRoute = () => (
  <AuthenticatedRoleRoute role={UserRole.Admin}>
    <AdminLayout>
      <Outlet />
    </AdminLayout>
  </AuthenticatedRoleRoute>
);

export const MerchantRoute = () => (
  <AuthenticatedRoleRoute role={[UserRole.Merchant, UserRole.MerchantOperator]}>
    <MerchantLayout>
      <Outlet />
    </MerchantLayout>
  </AuthenticatedRoleRoute>
);
export const OperatorRoute = () => (
  <AuthenticatedRoleRoute role={UserRole.Operator}>
    <OperatorLayout>
      <Outlet />
    </OperatorLayout>
  </AuthenticatedRoleRoute>
);
export const TechOperatorRoute = () => (
  <AuthenticatedRoleRoute role={UserRole.TechOperator}>
    <TechOperatorLayout>
      <Outlet />
    </TechOperatorLayout>
  </AuthenticatedRoleRoute>
);
export const PublicRoute = () => {
  if (authUtils.isLoggedIn()) {
    return redirectToRoleDefault();
  }
  return <Outlet />;
};
export const TraderRoute = () => (
  <AuthenticatedRoleRoute role={UserRole.Trader}>
    <TraderLayout>
      <Outlet />
    </TraderLayout>
  </AuthenticatedRoleRoute>
);
